// Template types
export const TEMPLATE_TYPE_NEEDS = "needs";
export const TEMPLATE_TYPE_RISK = "risk__assessment";
export const TEMPLATE_TYPE_GENERIC = "generic";
export const TEMPLATE_TYPE_SAFEGUARDING = "safeguarding";
export const TEMPLATE_TYPE_INCIDENT = "incident";
export const TEMPLATE_TYPE_CARE_PLAN = "care_plan";
export const TEMPLATE_TYPE_CARE_PLAN_ACTION = "care_plan_action";
export const TEMPLATE_TYPE_MEDICAL_CONDITION = "medical_condition";
export const TEMPLATE_TYPE_SCREENING = "screening";
export const TEMPLATE_TYPE_CAPACITY = "capacity_mac";
export const TEMPLATE_TYPE_DOLS = "dols";
export const TEMPLATE_TYPE_CONSENT = "consent";

// GET TEMPLATES LIST
export const GET_ASSESSMENT_TEMPLATES =
  "app/ASSESSMENT_TEMPLATE/GET_ASSESSMENT_TEMPLATES";
export const GET_ASSESSMENT_TEMPLATES_SUCCESS =
  "app/ASSESSMENT_TEMPLATE/GET_ASSESSMENT_TEMPLATES_SUCCESS";
export const GET_ASSESSMENT_TEMPLATES_FAILURE =
  "app/ASSESSMENT_TEMPLATE/GET_ASSESSMENT_TEMPLATES_FAILURE";

// GET TEMPLATE
export const GET_ASSESSMENT_TEMPLATE =
  "app/ASSESSMENT_TEMPLATE/GET_ASSESSMENT_TEMPLATE";
export const GET_ASSESSMENT_TEMPLATE_SUCCESS =
  "app/ASSESSMENT_TEMPLATE/GET_ASSESSMENT_TEMPLATE_SUCCESS";
export const GET_ASSESSMENT_TEMPLATE_FAILURE =
  "app/ASSESSMENT_TEMPLATE/GET_ASSESSMENT_TEMPLATE_FAILURE";

// SAVE TEMPLATE
export const SAVE_ASSESSMENT_TEMPLATE =
  "app/ASSESSMENT_TEMPLATE/SAVE_ASSESSMENT_TEMPLATE";
export const SAVE_ASSESSMENT_TEMPLATE_SUCCESS =
  "app/ASSESSMENT_TEMPLATE/SAVE_ASSESSMENT_TEMPLATE_SUCCESS";
export const SAVE_ASSESSMENT_TEMPLATE_FAILURE =
  "app/ASSESSMENT_TEMPLATE/SAVE_ASSESSMENT_TEMPLATE_FAILURE";

// DELETE TEMPLATE
export const DELETE_ASSESSMENT_TEMPLATE =
  "app/ASSESSMENT_TEMPLATE/DELETE_ASSESSMENT_TEMPLATE";
export const DELETE_ASSESSMENT_TEMPLATE_SUCCESS =
  "app/ASSESSMENT_TEMPLATE/DELETE_ASSESSMENT_TEMPLATE_SUCCESS";
export const DELETE_ASSESSMENT_TEMPLATE_FAILURE =
  "app/ASSESSMENT_TEMPLATE/DELETE_ASSESSMENT_TEMPLATE_FAILURE";

// TOGGLE MODAL
export const TOGGLE_ASSESSMENT_MODAL =
  "app/ASSESSMENT_TEMPLATE/TOGGLE_ASSESSMENT_MODAL";
